import * as React from 'react'
import { useStyles } from './Title.styles'
import { Paragraph } from './Paragraph'

interface ITitleProps {
  children: string
  maxLength?: number
  className?: string
}

export const Title = ({ children, maxLength, className }: ITitleProps) => {
  const classes = useStyles()
  return (
    <Paragraph maxLength={maxLength} className={`${classes.root} ${className}`}>
      {children}
    </Paragraph>
  )
}
